const getters={
  title: state => state.route.title,
  hideNavBar: state => state.route.hideNavBar,
  showLeftBack: state => state.route.showLeftBack,
  mobile: state => state.user.mobile,
}

export default getters
